<p></p> <!-- a little hacky white space :) -->
<div class="content-section">
    <div class="allConversationsColumn">
        <h2>Conversations</h2>
        <div *ngIf="conversationsLoaded">
            <div class="conversation-item" *ngFor="let convos of kadyChainDailyConversations">
                <button (click)="handleConversationsDateSelection(convos)"
                    [ngClass]="selectedDailyConversations && selectedDailyConversations.Date === convos.Date ? 'selectedConversationButton' : 'unselectedConversationButton'">
                    {{this.DateReturner(convos)}}
                </button>
                <div class="conversation-item"
                    *ngIf="selectedDailyConversations && selectedDailyConversations.Date === convos.Date">
                    <div *ngFor="let convo of selectedDailyConversations.Conversations">
                        <button (click)="handleConversationSelection(convo)"
                            [ngClass]="selectedConversation && selectedConversation.CreationTimeUtc === convo.CreationTimeUtc ? 'selectedConversationButton' : 'unselectedConversationButton'">
                            {{this.ShortSummaryReturner(convo)}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="currentConversationColumn" *ngIf="selectedConversation">
        <p class="summary-title">Summary of the conversation:</p>
        <p class="summary-section" style="font-size:smaller">
            {{this.SummaryReturner(selectedConversation?.summarizedConversation)}}</p>
        <app-kadychain-chat-viewer class="video-player" *ngFor="let Responsepair of selectedConversation.Responses"
            [selectedConversationResponsePair]="Responsepair" [botName]="selectedConversation.BotName" [studentID]="studentID">
        </app-kadychain-chat-viewer>

    </div>
</div>